import { TableCell, TableRow,Button } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import ProceduresManualContext from './ProceduresManualContext';

const ProceduresManualTableItem = ({ procedure }) => {


   const context = React.useContext(ProceduresManualContext);
 

   const TextStyleContainer = styled.div`

   font-family: Roboto;
   font-size: 14px;
   font-weight: 500;
   line-height: 19px;
   text-align: left;
   
   `;

    const {sdn,url,categoryName,rev,status,title,applicability} = procedure;

    const {actionGroupForDisplayedProcedureManual = {}} = context.procedureManual;
    const {readOnly} = actionGroupForDisplayedProcedureManual;

    return (
   
        <TableRow>
                <TableCell style={{padding:`0px 0px 0px 10px`}}>
                    <div />
                </TableCell>
                <TableCell>
                    {(url && !readOnly) ? 
                     <a target="_blank" href={url}>{sdn}</a>
                      :  sdn
                      }
                </TableCell>
                <TableCell>
                    {title}
                </TableCell>
                <TableCell>
                 {categoryName}
                </TableCell>
                <TableCell>
                    {rev}
                </TableCell>
                <TableCell>
                    {applicability}
                </TableCell>
                {!readOnly &&
                <TableCell>
                {(procedure.deviationReasoning || procedure.deviationComments ) &&                     
                    <Button 
                    color="primary"
                    onClick={ () => context.displayDeviationReasoning(procedure)}
                >
                    View Reason
                     </Button>
                }
                </TableCell>
                }
                <TableCell>
                  {status}
                </TableCell>
            
            </TableRow>

          
        
    );


}


export default ProceduresManualTableItem;